import styled, { css } from 'styled-components'

export const GpsButtonStyle = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  margin-top: 15px;
  color: #fc0a7e;
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(252,10,126,0.6), 0 0 20px rgba(252,10,126,0.4), 0 0 30px rgba(252,10,126,0.2);
  text-transform: uppercase;

  @media (max-width: 400px) {
    font-size: 0.8rem;
  }
  svg {
    margin-right: 8px;
    font-size: 1.2rem;
    ${props => props.theme?.rtl && css`
      margin-left: 8px;
      margin-right: 0px;
    `}
  }

  p {
    margin: 0;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
